import { captureException } from '@sentry/browser'
import {
  ShareInfoFragment,
  ShareInfoFragmentDoc,
  useVersionUploadProcessedSubscription,
} from 'gqlTypes'
import { dataIdFromObject } from 'graphql/apolloClient'
import { useEventDispatch } from 'utils'

declare module 'utils' {
  export interface EventsMap {
    shareWillBeUploaded: ShareInfoFragment
  }
}

export const useVersionUploadProcessed = () => {
  const onDocumentUpload = useEventDispatch('shareWillBeUploaded')

  // Subscription receiving a new processed version (it happens after versionUploadComplete)
  useVersionUploadProcessedSubscription({
    onSubscriptionData: ({ client, subscriptionData }) => {
      const share = subscriptionData.data?.versionUploadProcessed

      if (share) {
        // We need to trigger share update event before we update the cache
        // see https://github.com/sketch-hq/Cloud/issues/1394
        onDocumentUpload(share)

        // Prevent the UI from breaking
        try {
          client.writeFragment<ShareInfoFragment>({
            id: dataIdFromObject(share) as string,
            fragment: ShareInfoFragmentDoc,
            fragmentName: 'ShareInfo',
            data: share,
          })
        } catch (e) {
          captureException(e)
        }
      }
    },
    fetchPolicy: 'no-cache',
  })
}
